import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { UserSettingsAction } from '@cbridge-packages/user-settings';
import { ExposureDashboardAction } from '../exposureDashboard.action';
import { EXPOSURE_VIEW_MODE_SETTING_KEY } from '../exposureDashboard.constant';

/** Every flat/tree switch is written to the profile; the selector restores it on the next visit. */
export const persistExposureViewModeEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(ExposureDashboardAction.setViewMode),
  map(({ payload }) => UserSettingsAction.saveSetting({ key: EXPOSURE_VIEW_MODE_SETTING_KEY, value: payload })),
);
